import request from '@/utils/request'

export function fetchList(data) {
  return request({
    url: '/CommissionSchemaType/List',
    method: 'post',
    data,
  })
}

export function getItem(id) {
  return request({
    url: '/CommissionSchemaType/Get',
    method: 'post',
    data: { id },
  })
}

export function createItem(data) {
  // console.log('createItem', data)

  return request({
    url: '/CommissionSchemaType/Create',
    method: 'post',
    data,
  })
}

export function updateItem(data) {
  // console.log('updateItem', data)

  return request({
    url: '/CommissionSchemaType/Update',
    method: 'post',
    data,
  })
}

export function deleteItem(data) {
  return request({
    url: '/CommissionSchemaType/Delete',
    method: 'delete',
    data,
  })
}
